import React from 'react';
import { connect } from 'react-redux';
import EditForm from 'components/team/EditForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import {
  updateTeam,
} from 'actions/Team';

import { clearModal } from 'actions';

import { Modal } from 'reactstrap';

const EditTeamModal = ({
  modalOpen,
  clearModal,
  updateTeam,
  team,
}) => {
  if (!team) return null;

  const clearEditTeamModal = clearModal.bind(null, 'TEAM_EDIT');

  const teamId = team._id;

  const onTeamSettingsSubmit = (formData, photoFile) => {
    updateTeam(teamId, formData, photoFile);
    clearEditTeamModal();
  };

  return (
    <Modal isOpen={modalOpen} toggle={clearEditTeamModal}>
      <StyledModalHeader
        data-testid="teamSettingsFormTitle"
        toggle={clearEditTeamModal}
      >
        Edit team settings
      </StyledModalHeader>
      <StyledModalBody>
        <EditForm
          team={team}
          onSubmit={onTeamSettingsSubmit}
          onCancel={clearEditTeamModal}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal, team }) => {
    return {
      team,
      modalOpen: modal && modal.type === 'TEAM_EDIT',
    };
  },
  {
    updateTeam,
    clearModal,
  },
)(EditTeamModal);
